import React from 'react';
import ReactDOM from 'react-dom/client';
import { Auth0Provider } from '@auth0/auth0-react';
import App from './App';
import './index.css';

// Get Auth0 configuration from environment variables
const domain = import.meta.env.VITE_AUTH0_DOMAIN;
const clientId = import.meta.env.VITE_AUTH0_CLIENT_ID;
const audience = import.meta.env.VITE_AUTH0_AUDIENCE;

// Validate required environment variables
if (!domain || !clientId) {
  throw new Error(
    'Missing required Auth0 configuration. ' +
    'Please set VITE_AUTH0_DOMAIN and VITE_AUTH0_CLIENT_ID environment variables. ' +
    'See .env.example for reference.'
  );
}

console.log('🔐 Auth0 Configuration Loaded:');
console.log('   Domain:', domain);
console.log('   Client ID:', clientId.substring(0, 8) + '...');
console.log('   Audience:', audience || '(not set)');

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Auth0Provider
      domain={domain}
      clientId={clientId}
      authorizationParams={{
        redirect_uri: window.location.origin + '/auth/callback',
        audience: audience,
        // offline_access scope enables refresh tokens
        scope: 'openid profile email offline_access',
      }}
      // Store tokens in localStorage for persistence across page refreshes
      // This provides better UX (users stay logged in) at minimal security cost
      // for non-financial applications like fantasy pools
      cacheLocation="localstorage"
      // Enable refresh token rotation for automatic token renewal
      // Access tokens expire after 24h, refresh tokens handle silent renewal
      useRefreshTokens={true}
      // Fall back to silent auth iframe when refresh token is unavailable
      useRefreshTokensFallback={true}
    >
      <App />
    </Auth0Provider>
  </React.StrictMode>,
);
